import { render, staticRenderFns } from "./surgery-annotations-modal.vue?vue&type=template&id=11469ff2&scoped=true"
import script from "./surgery-annotations-modal.vue?vue&type=script&lang=ts"
export * from "./surgery-annotations-modal.vue?vue&type=script&lang=ts"
import style0 from "./surgery-annotations-modal.vue?vue&type=style&index=0&id=11469ff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11469ff2",
  null
  
)

export default component.exports